import { render, staticRenderFns } from "./Page032.vue?vue&type=template&id=ab8cb0c6&scoped=true&"
import script from "./Page032.vue?vue&type=script&lang=js&"
export * from "./Page032.vue?vue&type=script&lang=js&"
import style0 from "./Page032.vue?vue&type=style&index=0&id=ab8cb0c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab8cb0c6",
  null
  
)

export default component.exports
import {QToolbar,QToolbarTitle,QSpace,QSelect,QIcon,QInput,QPopupProxy,QDate,QBtn,QCard,QCardSection,QSeparator,QMarkupTable,QTable,QTd,QChip,QTooltip,QList,QItem,QItemSection,QItemLabel,QScrollArea,QInnerLoading,QSpinnerGears,QDialog,QBar,QPopupEdit,ClosePopup} from 'quasar'
component.options.components = Object.assign({QToolbar,QToolbarTitle,QSpace,QSelect,QIcon,QInput,QPopupProxy,QDate,QBtn,QCard,QCardSection,QSeparator,QMarkupTable,QTable,QTd,QChip,QTooltip,QList,QItem,QItemSection,QItemLabel,QScrollArea,QInnerLoading,QSpinnerGears,QDialog,QBar,QPopupEdit}, component.options.components || {})
component.options.directives = Object.assign({ClosePopup}, component.options.directives || {})
